/**
 * Brak wartości — jeden znak dla całej aplikacji.
 *
 * Naprawdę pusta komórka wygląda jak błąd ładowania, a „N/A”, „-”, „0 PLN”
 * i pusty string to cztery zapisy tego samego.
 *
 * Dwa wyjścia, bo są dwa konteksty: znak wchodzi też do napisów składanych
 * w maperach (`amountLabel`, dopiski kafli), gdzie nie ma na czym powiesić
 * klasy — tam idzie stała, a w JSX komponent, który dokłada barwę.
 */
export const EMPTY_VALUE = '—';

export const EmptyValue = () => (
  <span className="text-neutral-300">{EMPTY_VALUE}</span>
);
